import { useEffect, useRef } from "react";

import JSONEditor from "jsoneditor";
import "jsoneditor/dist/jsoneditor.css";
import { Box, Button, HStack, Portal } from "@chakra-ui/react";
import { getEditedGeoJSON } from "../../../../../utilies/geojson/GetEditedGeojson";
import { loadGeoJSONToCesium } from "../../../../../utilies/geojson/LoadGeojson";
import { showToast } from "../../../../../utilies/Utility";
import Type from "../../../../../utilies/Types";
import { useAppStore } from "../../../../../context/store";
import { useMapObjects } from "../../../../../context/MapObjectsContext";
const JsonEditor = () => {
  // state
  const showJsonEditor = useAppStore((s) => s.showJsonEditor);
  const currentLayerForJsonEditor = useAppStore((s) => s.currentLayerForJsonEditor);

  // setters / refs
  const setShowJsonEditor = useAppStore.getState().setShowJsonEditor;
  const setCurrentLayerForJsonEditor = useAppStore.getState().setCurrentLayerForJsonEditor;
  const viewerRef = useAppStore.getState().viewerRef;
  const { setMapObjects } = useMapObjects();

  const containerRef = useRef(null);
  const editorRef = useRef(null);

  useEffect(() => {
    if (!showJsonEditor) return;
    if (!currentLayerForJsonEditor) return;
    editorRef.current = new JSONEditor(containerRef.current, {
      mode: "code",
      modes: ["tree", "code", "form", "text", "view"],
    });

    let g = getEditedGeoJSON(currentLayerForJsonEditor);

    editorRef.current.set(g);
    return () => {
      editorRef.current.destroy();
    };
  }, [currentLayerForJsonEditor, showJsonEditor]);

  return (
    <Portal>
      <Box ref={containerRef} position="fixed" top="0" left="0" width="100%" height="100%" zIndex={1005} display={showJsonEditor ? "block" : "none"} data-allow-hotkeys="up,left,down,right,Enter">
        <HStack position={"absolute"} bottom={"20px"} right={"20px"} zIndex={1006}>
          <Button
            colorPalette={"red"}
            onClick={() => {
              setShowJsonEditor(false);
              setCurrentLayerForJsonEditor(null);
            }}
          >
            Cancel
          </Button>
          <Button
            colorPalette={"green"}
            onClick={async () => {
              if (!viewerRef.current || !currentLayerForJsonEditor?.dataSource || !editorRef.current) return;

              let parsedData;
              try {
                parsedData = JSON.parse(editorRef.current.getText());
              } catch (err) {
                console.error("Invalid JSON:", err);
                showToast("Invalid JSON format. Please correct it before saving", Type.NOTIFICATION.ERROR);
                return;
              }

              try {
                viewerRef.current.dataSources.remove(currentLayerForJsonEditor.dataSource);

                const newDs = await loadGeoJSONToCesium({
                  viewer: viewerRef.current,
                  geojson: parsedData,
                  options: currentLayerForJsonEditor.options,
                  geojsonType: currentLayerForJsonEditor.type,
                  layerName: currentLayerForJsonEditor.file_name,
                  id: currentLayerForJsonEditor.id,
                });

                setMapObjects((prev) => prev.map((o) => (o.id === currentLayerForJsonEditor.id ? { ...o, dataSource: newDs, is_edited: true } : o)));

                setShowJsonEditor(false);
                showToast("GeoJSON updated successfully", Type.NOTIFICATION.SUCCESS);
                setCurrentLayerForJsonEditor(null);
              } catch (err) {
                console.error("Failed to reload GeoJSON:", err);
                showToast("Failed to update GeoJSON layer", Type.NOTIFICATION.ERROR);
              }
            }}
          >
            Update
          </Button>
        </HStack>
      </Box>
    </Portal>
  );
};

export default JsonEditor;
